import {DASHBOARD_LINKS, AUTH, SPONSORSHIPS} from "../constants";
import {api, Logger} from "./index";

const LoginStatesEnum = {
    PENDING: 0,
    FAILED: 1,
    SUCCESS: 2
};

export default class AuthClass {
    constructor() {
        this.loginStatesEnum = LoginStatesEnum;
        this.userDataPendingPromises = [];
        this.cache = {};
        this.userLoginState = LoginStatesEnum.PENDING;
        this._fetchUserData();
    }

    isUserLoggedIn() {
        return this.userLoginState === LoginStatesEnum.SUCCESS
    }

    getUserLoginState() {
        return this.userLoginState
    }

    getUser() {
        // user login is done and failed
        if (this.userLoginState === LoginStatesEnum.FAILED) {
            return new Promise((resolve, reject) => {
                reject(new Error('Not logged in'))
            })
        }

        // user is logged in and there is cached data
        if (this.userLoginState === LoginStatesEnum.SUCCESS) {
            return new Promise((resolve, reject) => {
                this._resolveUserDataPromise(resolve, reject, this.cache.userData)
            })
        }

        // user login is pending
        return new Promise((resolve, reject) => {
            this.userDataPendingPromises.push({resolve, reject})
        })
    }

    getSponsorships() {
        // User login state is done and failed
        if (this.userLoginState === LoginStatesEnum.FAILED) {
            return new Promise((resolve, reject) => {
                return reject(new Error('Not logged in'))
            })
        }

        // User is logged in and there is cached data
        if (this.userLoginState === LoginStatesEnum.SUCCESS) {
            return new Promise((resolve, reject) => {
                this._fetchUserSponsorshipsData(resolve, reject, this.cache.userData)
            })
        }

        // User login is pending
        return new Promise((resolve, reject) => {
            this.userDataPendingPromises.push({ resolve: () => {
                this._fetchUserSponsorshipsData(resolve, reject, this.cache.userData)
            }, reject }) 
        })
    }

    /**
     * return a connection url to a provider,
     * if no provider specified, the url will direct to dashboard
     * @param provider
     * @returns {string}
     */
    getConnectionUrl(provider) {
        if (!provider || provider === 'dashboard') {
            return DASHBOARD_LINKS.WELCOME_BACK
        }
        return (provider === 'twitch' ? AUTH.LOGIN.TWITCH : AUTH.LOGIN.GOOGLE);
    }

    _resolveUserDataPromise(resolve, reject, userData) {
        if (userData) {
            resolve(this.cache.userData)
        } else {
            reject(new Error('user not logged in'))
        }
    }

    _onUserDataFetched(data) {
        this.userLoginState = data ? LoginStatesEnum.SUCCESS : LoginStatesEnum.FAILED;
        this.cache.userData = data;

        this.userDataPendingPromises.forEach((promiseObject) => {
            this._resolveUserDataPromise(promiseObject.resolve, promiseObject.reject, data)
        });
        this.userDataPendingPromises = []
    }

    _fetchUserData() {
        const uri = AUTH.URL_GET_CURRENT_USER;
        api.get(uri)
            .then((response) => {
                if (response.status === 200) {
                    return this._onUserDataFetched(response.data) // logged in
                }
                this._onUserDataFetched(null) // not logged in
            })
            .catch((error) => {
                console.error('login failed',error);
                this._onUserDataFetched(null)
            })
    }

    _fetchUserSponsorshipsData(resolve) {
        // Early return to prevent API call if sponsorships already exist
        if (this.sponsorships) {
            return resolve(this.sponsorships);
        }

        const uri = `${ SPONSORSHIPS.URL_GET_SPONSORSHIPS }?state=open`;
        api.get(uri)
            .then((response) => {
                if (response.status === 200) {
                    return resolve(this._onUserSponsorshipsDataFetched(response.data)) // logged in
                }
                resolve(this._onUserSponsorshipsDataFetched(null)) // not logged in
            })
            .catch((error) => {
                console.error('login failed',error);
                resolve(this._onUserSponsorshipsDataFetched(null))
            })
    }

    _onUserSponsorshipsDataFetched(data) {
        this.sponsorships = data.sponsorships || []
        return this.sponsorships;
    }
}



// WEBPACK FOOTER //
// ./src/services/Auth.js